var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useLayout } from "@/hooks/layout";
import ErrorPage from "@/pages/errorPage";
import { useGetModuleViewQuery } from "@/store/mvc";
import { useParams } from "react-router";
export default function WidgetError(_a) {
    var _b;
    var widget = _a.widget;
    var _c = useParams(), queryModuleName = _c.module, queryAction = _c.action, queryRecord = _c.record;
    var layout = useLayout();
    var moduleName = queryModuleName || "Home";
    var action = queryAction || "index";
    var record = queryRecord || "";
    var _d = useGetModuleViewQuery({
        moduleName: moduleName,
        action: action,
        record: record,
    }), moduleViewResult = _d.data, moduleViewError = _d.error, isLoading = _d.isLoading, isFetching = _d.isFetching, isError = _d.isError;
    var err = moduleViewError;
    var status = (err === null || err === void 0 ? void 0 : err.status) || 500;
    var message = ((_b = err === null || err === void 0 ? void 0 : err.data) === null || _b === void 0 ? void 0 : _b.message) || "Module not found";
    return (_jsx("div", __assign({ className: "w-full h-full mt-2 overflow-scroll" }, { children: _jsx(ErrorPage, { code: status, msg: message }) })));
}
widgetsDictionary.register("widget/error", {
    name: "Widget Error",
    display: WidgetError,
});
